import type { ThemeConfig } from "../../types";

export const minimalTheme: ThemeConfig = {
  weak: { color: "#e0e0e0", label: "1/4" },
  fair: { color: "#9e9e9e", label: "2/4" },
  good: { color: "#616161", label: "3/4" },
  strong: { color: "#212121", label: "4/4" },
};
